import { render } from "./NewMember.vue?vue&type=template&id=03227800&ts=true"
import script from "./NewMember.vue?vue&type=script&lang=ts"
export * from "./NewMember.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__